import { css } from 'styled-components';
import { InputGroup } from '../../components/InputGroup';
import { FormComponentProps } from '../../components/types';
import { getTextStyles, theme } from '../../theme';
import { inputVariableStyles } from './variables';

const { colors, radius, sizes, text } = theme;

/**
 * @deprecated
 * Styles in this file have been converted to CSS modules in src/utils/forms/form.module.scss
 */
export const inputFocusStyles = ({ hasError }: FormComponentProps) => css`
  &:focus {
    --border-color: ${hasError ? colors.secondary.red.base : colors.secondary.blue.base};
    border-color: var(--border-color);
    box-shadow: 0 0 0 var(--outline-size) var(--shadow-color);
    outline: 0;
  }
`;
/**
 * @deprecated
 * use css modules instead
 */
export const inputDisabledStyles = css`
  &:disabled,
  &[data-disabled] {
    opacity: 1;
    box-shadow: none;
    background-color: ${colors.neutral.grey.light};
    cursor: not-allowed;
  }
`;

/**
 *
 * @deprecated
 * use css modules instead
 */
export const inputBaseStyles = ({ compact }: FormComponentProps) => css`
  ${inputVariableStyles}
  ${getTextStyles(text.body)}

  appearance: none;
  box-sizing: border-box;

  background-color: white;
  text-align: left;

  min-height: ${compact ? sizes[8] : sizes[10]};
  padding-inline: var(--padding);
  border: 1px solid var(--border-color);
  border-radius: ${radius.base};

  display: flex;
  align-items: center;
  justify-content: flex-start;

  /* When inside an InputGroup, reduce inline padding to bring content closer together */
  ${InputGroup} > &:first-child {
    padding-right: calc(var(--padding-right) - ${sizes[1]});
  }

  ${InputGroup} > &:last-child {
    padding-left: ${sizes[2]};
  }

  ${InputGroup} > &:not(:first-child):not(:last-child) {
    padding-inline: ${sizes[2]};
  }
`;

/**
 * @deprecated
 * use css modules instead from src/utils/forms/form.module.scss
 */
export const inputFullStyles = css`
  ${inputBaseStyles}
  ${inputDisabledStyles}
  ${inputFocusStyles}

  &::placeholder {
    ${getTextStyles(text.placeholder)}
  }

  &:invalid {
    box-shadow: 0 0 0 var(--outline-size) var(--shadow-color);
    border-color: ${colors.secondary.red.base};
  }
`;
